import PropTypes from 'prop-types';
// @flow

import React, { Component } from 'react';
import _ from 'lodash';
import I18n from 'PMT/i18n/I18n';
import Constants from 'constants/Constants';
import classNames from 'classnames';

import DateUtils from 'PMT/utils/DateUtils';

// -- entities
import AvailabilityHour from 'PMT/entities/menu/AvailabilityHour';
import AvailabilityHoursForDay from 'PMT/entities/menu/AvailabilityHoursForDay';

// -- views
import AvailabilityHourView from './AvailabilityHourView';

class AvailabilityHoursForDayView extends Component {

  static defaultProps = {
    readOnly: false
  };

  static propTypes = {
    availabilityHoursForDay: PropTypes.objectOf(AvailabilityHoursForDay).isRequired,

    suggestedHour: PropTypes.object.isRequired,

    day: PropTypes.number.isRequired,

    readOnly: PropTypes.bool,

    /**
     * @param dayIndex
     */
    onAddAvailabilityClick: PropTypes.func.isRequired,

    /**
     * @param dayIndex
     * @param Array<AvailabilityHour>
     */
    onChangeForDay: PropTypes.func.isRequired,
  };

  getDayLabel() {
    switch (this.props.day) {
      case Constants.Day.MONDAY:
        return I18n.tr('global.days.monday');

      case Constants.Day.TUESDAY:
        return I18n.tr('global.days.tuesday');

      case Constants.Day.WEDNESDAY:
        return I18n.tr('global.days.wednesday');

      case Constants.Day.THURSDAY:
        return I18n.tr('global.days.thursday');

      case Constants.Day.FRIDAY:
        return I18n.tr('global.days.friday');

      case Constants.Day.SATURDAY:
        return I18n.tr('global.days.saturday');

      case Constants.Day.SUNDAY:
        return I18n.tr('global.days.sunday');

      default:
        return '';
    }
  }

  getStatus(): string {
    if (this.isAvailableForWholeDay() && this.props.availabilityHoursForDay.hours.length > 0) {
      return 'day';
    } else if (!this.isAvailableForWholeDay() && this.props.availabilityHoursForDay.hours.length > 0) {
      return 'hours';
    } else if (!this.isAvailableForWholeDay() && this.props.availabilityHoursForDay.hours.length === 0) {
      return 'off';
    }
  }
  //
  //
  //

  isAvailableForWholeDay(): boolean {
    return this.props.availabilityHoursForDay.isAvailableForWholeDay();
  }

  onClickLabelWholeDay = () => {
    if (this.props.readOnly) {
      return
    }
    const availabilityHoursForDay = this.props.availabilityHoursForDay;

    availabilityHoursForDay.setAvailableForWholeDay()
    this.props.onChangeForDay(this.props.day, availabilityHoursForDay);
  };

  onClickLabelHours = () => {
    if (this.props.readOnly) {
      return
    }
    const availabilityHoursForDay = this.props.availabilityHoursForDay;

    if (availabilityHoursForDay.isAvailableForWholeDay()) {
      availabilityHoursForDay.resetHours()
    }
    availabilityHoursForDay.addHour(this.props.suggestedHour);

    // if this.props.suggestedHour was for whole day we replace it
    if (availabilityHoursForDay.isAvailableForWholeDay()) {
      availabilityHoursForDay.resetHours()
      availabilityHoursForDay.setAvailableOnDay()
    }

    this.props.onChangeForDay(this.props.day, availabilityHoursForDay);
  };

  onClickLabelOff = () => {
    if (this.props.readOnly) {
      return
    }
    const availabilityHoursForDay = this.props.availabilityHoursForDay;

    availabilityHoursForDay.setNotAvailableForWholeDay();
    this.props.onChangeForDay(this.props.day, availabilityHoursForDay);
  };

  onDelete = (availabilityHour: AvailabilityHour) => {
    if (this.props.readOnly) {
      return
    }
    const availabilityHoursForDay = this.props.availabilityHoursForDay;

    availabilityHoursForDay.deleteHour(availabilityHour);

    this.props.onChangeForDay(this.props.day, availabilityHoursForDay);
  };

  // -- renderers
  renderList() {
    const availabilityHoursForDayListView = [];

    const sortedOpeningHours = _.sortBy(
      this.props.availabilityHoursForDay.hours,
      ['asc'],
      (hour): number => {
        return hour.opening;
      }
    );

    let i = 0; // handle if there is same two hours.
    _.each(sortedOpeningHours, (availabilityHour: AvailabilityHour) => {
      availabilityHoursForDayListView.push(
        <AvailabilityHourView
          key={i}
          availabilityHour={availabilityHour}
          onDelete={this.onDelete}
          readOnly={this.props.readOnly}
        />
      );
      ++i;
    });

    return availabilityHoursForDayListView;
  }

  renderAddForDayBtn() {
    if (this.props.readOnly) {
      return null
    }
    return (
      <div
        className="btn btn-primary btn-add"
        onClick={() => this.props.onAddAvailabilityClick(this.props.day)}
      >
        <i
          className="fa fa-plus"
        />
        &nbsp;
        {I18n.tr('components.availibility_hours.form.add_opening_hour')}
      </div>
    );
  }

  renderAvailableForWholeDay() {
    const labelClassName = classNames('btn btn-primary', {
      'active': !this.isAvailableForWholeDay() && !_.isEmpty(this.props.availabilityHoursForDay.hours.length)
    });

    return (
      <div className="btn-group" data-toggle="buttons">
        <label
          className={`btn btn-primary btn-xs ${this.getStatus() === 'day' && 'active'}`}
          onClick={this.onClickLabelWholeDay}
        >
          {I18n.tr('components.availibility_hours.form.whole_day')}
        </label>
        <label
          className={`btn btn-primary btn-xs ${this.getStatus() === 'hours' && 'active'}`}
          onClick={this.onClickLabelHours}
        >
          {I18n.tr('components.availibility_hours.form.custom_hours')}
        </label>
        <label
          className={`btn btn-primary btn-xs ${this.getStatus() === 'off' && 'active'}`}
          onClick={this.onClickLabelOff}
        >
          {I18n.tr('components.availibility_hours.form.off')}
        </label>
      </div>
    );
  }

  render() {
    return (
      <div className="availability_hours_for_day">
        <h3>
          {_.capitalize(this.getDayLabel())}
        </h3>

        <div>
          {this.renderAvailableForWholeDay()}

          {this.getStatus() === 'day' &&
            <p>{I18n.tr('components.availibility_hours.form.whole_day.content')}</p>
          }
          {this.getStatus() === 'hours' &&
            <div>
              <p>{I18n.tr('components.availibility_hours.form.custom_hours.content')}</p>
              {this.renderList()}
              {this.renderAddForDayBtn()}
            </div>
          }
          {this.getStatus() === 'off' &&
            <p>{I18n.tr('components.availibility_hours.form.off.content')}</p>
          }
        </div>
      </div>
    );
  }

}

export default AvailabilityHoursForDayView;



// WEBPACK FOOTER //
// ./scripts/pages/menu/components/availabilityHours/AvailabilityHoursForDayView.js